/** fileName: Loading.jsx
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import React from 'react';
import CircularProgress from "@mui/material/CircularProgress";
import {Box} from "@mui/material";
import './loading.css';

const Loading = ({placeHolder = false, sx = null}) => {
    let defStyle = {
        left: placeHolder ? 'auto' : "50%",
        top: placeHolder ? 'auto' : "50%",
        transform: placeHolder ? '0, 0' : "translate(-50%,-50%)",
        position: placeHolder ? 'static' : "fixed",
        display: "flex",
        height: "100px",
        width: "100px",
        zIndex: 99999,
        alignItems: "center",
        justifyContent: "center"
    };


    const ParentChild = ({children}) => {
        return placeHolder ? (<Box className={'parentChild'}>{children}</Box>) : (children);
    }


    return (
        <ParentChild>
            <div style={defStyle}>
                <CircularProgress color={"success"} sx={sx}/>
            </div>

        </ParentChild>
    );
};

export default Loading;